import { Button } from "@material-ui/core";
import React from "react";

type Props = {
	onNewProcess: () => void;
};

const NewProcessStatusBar = ({ onNewProcess }: Props) => {
	return (
		<Button variant="contained" color="primary" onClick={onNewProcess}>
			NEW PROCESS
		</Button>
	);
};

export default NewProcessStatusBar;
